module.exports = __webpack_public_path__ + "img/subirArchivo.c2b8d859.svg";